module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/101-northern-cyprus-f4eac41e7fe53ca8d97fcd55e88ad5c9.svg";